import styled from "@emotion/styled";
import { m } from "framer-motion";
import { padding } from "polished";
import React from "react";

import { useFormSubmissionContext } from "@brexhq/next/src/components/modules/LeadForm/FormSubmissionProvider";
import { LeadFormSteps } from "@brexhq/next/src/components/modules/LeadForm/machines/types";
import useAnalytics from "@brexhq/next/src/hooks/useAnalytics";
import { FormStepViewedEvent } from "@brexhq/next/src/telemetry/analyticsEvents";

export const FinalStateViewTemplatePage = styled(m.div)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "100%",
  [theme.breakpoints.phone]: {
    ...padding(theme.navHeights.desktop, 0),
    overflowY: "auto",
    display: "block",
  },
}));

export interface FinalStateViewTemplateProps {
  children: React.ReactNode;
  currentLeadFormStep:
    | LeadFormSteps.waitlist
    | LeadFormSteps.success
    | LeadFormSteps.password
    | LeadFormSteps.eventSuccess;
}

export const FinalStateViewTemplate: React.FC<
  React.PropsWithChildren<FinalStateViewTemplateProps>
> = ({ children, currentLeadFormStep }) => {
  const { form } = useFormSubmissionContext();
  const { trackEvent } = useAnalytics();
  const { setProgress, setShowFinalStateView, programName } = form;

  React.useEffect(() => {
    const formValues = form?.getValues() || {};
    setProgress(7 / 7);
    setShowFinalStateView(true);
    trackEvent(
      new FormStepViewedEvent(currentLeadFormStep, programName, formValues),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const waitlistAnimationVariants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? 500 : -500,
        opacity: 0,
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
  };

  return (
    <FinalStateViewTemplatePage
      variants={waitlistAnimationVariants}
      custom={1}
      initial="enter"
      animate="center"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.5 },
      }}
    >
      {children}
    </FinalStateViewTemplatePage>
  );
};
